<template>
  <div class="decrypt-img">
    <img-load class="decrypt-img"
      v-if="decryptBlob"
      :src="decryptBlob"
      fit="contain"
      @load="onImgLoad"
      v-bind="$attrs"
    ></img-load>
  </div>
</template>

<script>
import { decryptTool } from "./tool";

export default {
  name: "LongText",
  props: ["src", "origin", "iPreviewSrcList"],
  emit: ["load"],
  data() {
    return {
      decryptBlob: null,
    };
  },
  computed: {
    previewSrcList() {
      if (this.iPreviewSrcList) return this.iPreviewSrcList;
      if (this.decryptBlob) return [this.decryptBlob];
      return [];
    }
  },
  watch: {
    src: {
      async handler(val) {
        const url = val.startsWith('http') ? val : this.$imgUrl + "/" + val;
        this.decryptBlob = !this.origin
          ? await decryptTool.imgDecypt(url)
          : this.src;
      },
      immediate: true,
    },
  },
  mounted() {
    
  },
  methods: {
    onImgLoad(e) {
      this.$emit("load", {
        event: e,
        blob: this.decryptBlob,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.decrypt-img {
  width: 100%;
  height: 100%;
}
</style>
